// extracted by mini-css-extract-plugin
module.exports = {"modalFormContent":"EditDerivedEnergyConsumptionModal_modalFormContent__1r_XK"};